(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
(function() {
  function shuffleTail(container) {
    var n = parseInt(container.getAttribute('data-shuffle-after'), 10);
    if (!n || n < 1) return;
    var cards = Array.prototype.filter.call(container.children, function (el) {
      return el.tagName === 'PRODUCT-CARD' || el.matches('product-card, .product-card');
    });
    if (cards.length <= n) return;
    var tail = cards.slice(n);
    for (var i = tail.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = tail[i]; tail[i] = tail[j]; tail[j] = tmp;
    }
    tail.forEach(function (el) { container.appendChild(el); });
  }
  function run() {
    document.querySelectorAll('[data-shuffle-after]').forEach(shuffleTail);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
